import { Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SyncfusionService } from 'src/app/services/syncfusion.service';

@Component({
  selector: 'app-openpo-column-molecule',
  templateUrl: './openpo-column-molecule.component.html',
  styleUrls: ['./openpo-column-molecule.component.scss']
})
export class OpenpoColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Input() reportName: any;
  infoData: any;
  ELEMENT_DATA: any;
  dialogVisible: boolean = false;
  dialogTitle: string = 'Purchase Order Details';
  dialogColumns: string[] = ['code', 'supplierCode', 'qty', 'purchaseOrderDate'];
  unavailableData: any;
  showOrderQTY: { code: string; shortage: number }[];
  dataSourcePurchaseOrder = new MatTableDataSource<any>([]);
  objectQTYHeader: string[];
  imgFlag: boolean;
  imgUrl: any;

  constructor(private syncfusion: SyncfusionService) { }

  public onOpenDialog = (event: any, input): void => {
    if (this.isProjectionInfoColumn()) {
      this.infoData = event;
      this.dialogTitle = this.header?.headerText === 'Firm (1st Month)' ? 'Firm Details' : 'Projection Details';
      this.dialogColumns = this.header?.headerText === 'Firm (1st Month)'
        ? ['channelCode', 'oneMonthFirm']
        : ['channelCode', 'twoMonthRolling'];
      this.syncfusion
        .getPaginatedSyncfusionData('channel_wise_projection', {
          gridFilters: [
            {
              column: 'materialCode',
              condition: 'EQUAL',
              value: event.materialCode || event.sku,
              type: 'STRING'
            }
          ]
        })
        .subscribe((response: any) => {
          this.ELEMENT_DATA = response?.items || [];
          this.dataSourcePurchaseOrder = new MatTableDataSource<any>(
            this.ELEMENT_DATA
          );
          this.dialogVisible = true;
        }, () => {
          this.dialogVisible = false;
        });
    } else if (input === "openPOQty") {
      this.infoData = event;
      this.dialogTitle = 'Purchase Order Details';
      this.dialogColumns = ['code', 'supplierCode', 'qty', 'purchaseOrderDate'];
      this.syncfusion
        .getWithCache(
          event.materialCode || event.sku,
          event.locationCode || event.location,
          event.supplierCode
        )
        .then((response) => {
          this.ELEMENT_DATA = response;
          this.dataSourcePurchaseOrder = new MatTableDataSource<any>(
            this.ELEMENT_DATA
          );
          this.dialogVisible = true;
        })
        .catch((error) => {
          this.dialogVisible = false;
        });
    } else if (input === "canOrderQty") {
      this.showOrderQTY = event.shortage_json ? JSON.parse(event.shortage_json) : [];
      this.objectQTYHeader = Object.keys(this.showOrderQTY);
      event.showOrders = true;
    }
  };

  isProjectionInfoColumn(): boolean {
    return this.reportName === 'Production_Intent_Planning'
      && ['Firm (1st Month)', 'Proj. (2nd Month)'].includes(this.header?.headerText);
  }

  shouldShowInfoIcon(): boolean {
    const value = this.data?.[this.header?.field];
    return value !== null && value !== undefined && value !== '' && Number(value) !== 0;
  }

  onOverlayClick() {
    this.infoData = [];
    this.dataSourcePurchaseOrder = new MatTableDataSource<any>([]);
    this.dialogTitle = 'Purchase Order Details';
    this.dialogColumns = ['code', 'supplierCode', 'qty', 'purchaseOrderDate'];
    if (this.dialogVisible) {
      this.dialogVisible = false;
      return;
    }
  };
  modifyName(name) {
    if (name == "qty") {
      return "Quantity";
    } else if (name == "code") {
      return "Order Number";
    } else if (name == "purchaseOrderDate") {
      return "Order Date";
    } else if (name == "channelCode") {
      return "Channel";
    } else if (name == "oneMonthFirm") {
      return "Firm";
    } else if (name == "twoMonthRolling") {
      return "Projection";
    } else {
      return "Supplier";
    }
  }
}
